import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import * as Icon from "react-bootstrap-icons";
import axios from "axios";
import Pagination from "react-bootstrap/Pagination";

const CommissionTable = () => {
  const [toggleValue, setToggleValue] = useState(false);
  const [commissionData, setCommissionData] = useState("");
  const [showReferredUsers, setShowReferredUsers] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);
  const [treeData, setTreeData] = useState(null);

  const authtoken = localStorage.getItem("token");
  const token = `Bearer ${authtoken}`;

  useEffect(() => {
    getParentData();
    fetchCommissionData();
  }, []);

  const fetchCommissionData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}userinfo/alluserdata`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      setCommissionData(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getParentData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}userinfo/tree`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const tree = transformDataToTree(response.data);
      tree.totalChildren = countChildren(tree);
      setTreeData(tree);
    } catch (error) {
      console.error("Error: " + error);
    }
  };

  const transformDataToTree = (data) => {
    const children = [];
    if (data.left_child) children.push(transformDataToTree(data.left_child));
    if (data.right_child) children.push(transformDataToTree(data.right_child));
    return {
      name: data.name,
      refCode: data.referral_code || "N/A",
      profilePhoto:
        data.profilePhoto ||
        "https://pronedvizhimost.ru/static/custom/img/default/user.png",
      children: children.length ? children : null,
      collapsed: false,
    };
  };

  const countChildren = (node) => {
    if (!node || !Array.isArray(node.children) || node.children.length === 0)
      return 0;
    node.totalChildren =
      node.children.length +
      node.children.reduce((acc, child) => acc + countChildren(child), 0);
    return node.totalChildren;
  };

  const referredUsers = commissionData?.referredUsers || [];
  const totalPages = Math.ceil(referredUsers.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginatedUsers = referredUsers.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  const renderPaginationItems = () => {
    const items = [];
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageClick(number)}
        >
          {number}
        </Pagination.Item>
      );
    }
    return items;
  };


  const downloadCSV = () => {
    const headers = [
      "SI",
      "Name",
      "Email",
      "Commission Amount",
      "Wallet Balance",
      "Total Users",
    ];

    const parentUserRow = commissionData?.parentUser
      ? [
        1,
        commissionData.parentUser.name,
        commissionData.parentUser.email,
        commissionData.parentUser.commissionBalance,
        commissionData.parentUser.walletBalance,
        countChildren(treeData),
      ]
      : [];

    const userRows = referredUsers.map((user, index) => [
      index + 2,
      user.name,
      user.email,
      user.commissionBalance,
      user.walletBalance,
      countChildren(treeData?.children?.[index]),
    ]);

    const csvContent = [headers, ...(parentUserRow.length ? [parentUserRow] : []), ...userRows]
      .map((row) => row.map((value) => `"${value}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "users.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2 p-0">
          <Sidebar toggleSidebar={toggleValue} setToggleValue={setToggleValue} />
        </div>

        <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
          {treeData && commissionData && (
            <div>
              <div className="mb-4">
                <h5>Commissions</h5>
                <h6 className="text-muted">View commissions</h6>
              </div>

              <div className="table-responsive">
                <table className="table table-striped table-hover text-center">
                  <thead>
                    <tr>
                      <th>SI</th>
                      <th>Name</th>
                      <th>Commission Amount</th>
                      <th>Wallet Balance</th>
                      <th>Total Users</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>{commissionData?.parentUser?.name}</td>
                      <td>
                        <Icon.CurrencyRupee />
                        {commissionData?.parentUser?.commissionBalance}
                      </td>
                      <td>
                        <Icon.CurrencyRupee />
                        {commissionData?.parentUser?.walletBalance}
                      </td>
                      <td>{treeData?.totalChildren || 0}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <button
                onClick={() => setShowReferredUsers(!showReferredUsers)}
                className="btn btn-dark my-3"
              >
                {showReferredUsers ? "Hide Referred Users" : "Show Referred Users"}
              </button>

              {showReferredUsers && (
                <>
                  <div className="table-responsive" style={{ maxHeight: "400px" }}>
                    <table className="table table-dark table-striped table-hover text-center">
                      <thead>
                        <tr>
                          <th>SI</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Commission Amount</th>
                          <th>Wallet Balance</th>
                          <th>Total Users</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          paginatedUsers.length > 0
                            ?
                            paginatedUsers.map((user, index) => (
                              <tr key={user.id || index}>
                                <td>{indexOfFirstItem + index + 1}</td>
                                <td>{user.name}</td>
                                <td>{user.email}</td>
                                <td>
                                  <Icon.CurrencyRupee />
                                  {user.commissionBalance}
                                </td>
                                <td>
                                  <Icon.CurrencyRupee />
                                  {user.walletBalance}
                                </td>
                                <td>{countChildren(treeData?.children?.[index] || {})}</td>
                              </tr>
                            ))
                            :
                            <tr>
                              <td colSpan="6" className="text-center p-5">
                                <span>No Referred Users Yet</span>
                              </td>
                            </tr>
                        }
                      </tbody>
                    </table>
                    <div className="mt-3">
                      {
                        paginatedUsers.length > 0 &&
                        <button className="btn btn-success" onClick={downloadCSV}>
                          Download CSV
                        </button>
                      }
                    </div>
                  </div>

                  {/* Pagination start */}
                  {
                    paginatedUsers.length > 0 &&
                    <div className="d-flex justify-content-center mt-4">
                      <Pagination>
                        <Pagination.First
                          onClick={() => handlePageClick(1)}
                          disabled={currentPage === 1}
                        />
                        <Pagination.Prev
                          onClick={handlePrevPage}
                          disabled={currentPage === 1}
                        />
                        {renderPaginationItems()}
                        <Pagination.Next
                          onClick={handleNextPage}
                          disabled={currentPage === totalPages}
                        />
                        <Pagination.Last
                          onClick={() => handlePageClick(totalPages)}
                          disabled={currentPage === totalPages}
                        />
                      </Pagination>
                    </div>
                  }
                  {/* Pagination end */}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommissionTable;